import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, TextField } from "@mui/material";
import { addNewGame, getGamesData } from "../redux/asyncThunk/userActions";
import { useNavigate } from "react-router-dom";
import { sanitizePlainText } from "../utils/inputValidation";
import { AUTH_FIELD_SX } from "../pages/AuthLayout";

export default function NewGame() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const games = useSelector((state) => state.user?.games);
  const user = useSelector((state) => state.user?.data?.user);

  const [textProject, setTextProject] = useState("");

  const checkGamesTitle = useCallback(
    (count) => !games.find((el) => el.title === `Новый проект-${count}`),
    [games]
  );

  useEffect(() => {
    if (!games?.length) {
      setTextProject("Новый проект-1");
    } else {
      let count = 1;
      while (!checkGamesTitle(count)) {
        count++;
      }
      setTextProject(`Новый проект-${count}`);
    }
  }, [checkGamesTitle, games]);

  return (
    <div className="app-dialog__body">
      <div className="app-dialog__title">Создайте проект</div>
      <TextField
        label="Название проекта"
        value={textProject}
        size="small"
        fullWidth
        sx={AUTH_FIELD_SX}
        onChange={(ev) =>
          setTextProject(sanitizePlainText(ev.target.value, 120))
        }
      />
      <div className="app-dialog__actions">
        <Button
          variant="contained"
          className="app-btn app-btn--primary"
          onClick={() => {
            const onSuccess = () => {
              dispatch(getGamesData({ id: user.id }));
              navigate("/main", { replace: true });
            };
            dispatch(addNewGame({ userId: user.id, textProject, onSuccess }));
          }}
        >
          Создать
        </Button>
      </div>
    </div>
  );
}
